<div fxLayout="column" fxLayoutAlign="center center">
  <img [src]="linkSrc" alt="" [ngStyle]="{'width':iconSize}">
  <h3 [style.font-size]="messageSize" *ngIf="!contentTemplate; else contentTemplate">{{message}}</h3>
</div>